import Icon from '../components/Icon';

const CollTrailStroller = Icon(
  'coll-trail-stroller',
  <>
    <path d="M7.875 19a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5M20.781 19a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5M6.368 0l.29.275 16.281 15.5c.22.21.323.496.308.778a1 1 0 0 1-.999 1.071H10.415a5 5 0 0 1-5-5.04L5.499 2H1.063a1 1 0 0 1 0-2z" />
  </>
);

export default CollTrailStroller;
